export default {
  'Cases types': 'ชนิดของเคส',
  'Possible contents of the case': 'เนื้อหาที่เป็นไปได้สำหรับเคส',
  'Other cases': 'เคสอื่นๆ',
  'Open for': 'เปิดให้',
};
